export const MESSAGE_KIND = "sign-in-repair-shop";
export const MESSAGE_NO_USER = "등록되지 않은 회원정보입니다.";
export const MESSAGE_INVALID_USER =
  "아이디 또는 비밀번호가 일치하지 않습니다. 5회 이상 틀릴 경우 로그인이 제한됩니다.";
export const NOT_APPROVED_USER = "귀하의 아이디는 승인 되지 않았습니다.";
